<template>
  <div>
    <v-card class="mb-8" elevation="0" style="background-color: #f2f2f2">
      <!-- <v-app-bar dark color="grey">
            <v-app-bar-nav-icon></v-app-bar-nav-icon>

            <v-toolbar-title
              >Mein Clearment | Login | Anspruch prüfen</v-toolbar-title
            >

            <v-spacer></v-spacer>

           <v-btn icon>
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-app-bar> -->
      <v-container v-if="user">
        <v-row>
          <v-col cols="12" md="12">
            <h2 class="green--text">Sie sind jetzt erfolgreich eingeloggt</h2>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-if="!user">
        <v-row dense>
          <v-col cols="12" md="4">
            <h2 class="redtext mt-4">Clearment Login</h2>
            <!-- <span class="smalltext"
              ><a @click="passForgot = !passForgot"
                >Sie haben Ihr Passwort vergessen</a
              >
            </span> -->
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="select.checkcheck"
              label="mein Clearment Passwort"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="pt-4">
            <v-badge bordered color="red" icon="mdi-lock" overlap>
              <v-btn
                color="red"
                @click="startLogin()"
                class="button_caps"
                outlined
                tile
                >login</v-btn
              >
            </v-badge>
          </v-col>
        </v-row>
      </v-container>
      <v-card tile>
        <v-tabs vertical color="red">
          <v-tab style="color: red;" class="text-xs-left">
            <!-- <v-icon left style="color: #e54c39;">
          mdi-star
        </v-icon> -->
            <span class="button_caps"
              ><b>Erstattung prüfen</b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            >
          </v-tab>
          <v-tab style="color: red;">
            <span class="button_caps"><b>Erstattung reklamieren</b></span>
          </v-tab>

          <v-tab-item class="pa-4"
            ><h2 class="greytext">
              Sie sind unsicher ob Ihre Versicherung vollständig erstattet hat?
              <b class="red--text">Clearment hilft Ihnen.</b>
            </h2>
          </v-tab-item>
          <v-tab-item class="pa-4"
            ><h2 class="greytext">
              Ihre Versicherung weigert sich vollständig zu bezahlen?
              <b class="red--text"
                >Clearment hilft Ihnen diese Erstattung zu reklamieren.</b
              >
            </h2>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-card>
    <v-dialog width="666" v-model="passForgot">
      <div v-if="passSuccess">
        <v-alert type="success"
          ><h2>Wir haben Ihnen Ihr Passwort soeben zugesandt.</h2></v-alert
        >
      </div>
      <div v-if="!passSuccess">
        <v-card>
          <v-card-title>Sie haben Ihr Passwort vergessen?</v-card-title>
          <v-card-text>
            <v-text-field v-model="selectuser.passEmail" label="Ihre E-Mail" />
            Wir senden Ihnen Ihr Passwort per E-Mail zu.<br />
            <v-btn class="smallcaps" outlined color="blue" @click="resendPass()"
              >Passwort anfordern</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "index-login",
    components: {},

    data: function() {
      return {
        passForgot: false,
        selectuser: {
          passEmail: "",
        },
        passSuccess: false,
        select: {
          // checkcheck: "253540X67GX2M",
          checkcheck: "",
        },
        user: false,
      };
    },
    created() {},

    methods: {
      resendPass() {
        this.$store
          .dispatch("resendPass", this.selectuser)
          .then((resp) => {
            if (resp.data.success) {
              this.passSuccess = true;
            }
          })
          .catch((err) => {
            this.$log.error(err);
          });
      },
      startLogin() {
        this.$store.commit("start_loading_full");
        this.$store
          .dispatch("startLogin", this.select)
          .then((resp) => {
            this.$store.commit("stop_loading_full");
            if (resp.data.user.user_id) {
              this.$store.commit("user", resp.data.user);
              this.user = resp.data.user;
              this.$log.debug("StoreUser", this.$store.getters.getUserStore);
              this.$router.push("/vertragsschutz");
            }
          })
          .catch((err) => {
            this.$log.error(err);
          });
      },
    },
  };
</script>
